import { useQuery } from '@tanstack/react-query'
import { z } from 'zod/mini'
import { apiFetch } from './client'

export const healthReadySchema = z.object({
  status: z.enum(['ok', 'degraded']),
  checks: z.record(z.string(), z.string()),
})

export function useApiHealth() {
  return useQuery({
    queryKey: ['health', 'ready'],
    // 503 still carries the checks; surface them instead of throwing.
    queryFn: ({ signal }) =>
      apiFetch('/api/v1/health/ready', { schema: healthReadySchema, signal }).catch((err) => {
        if (err.status === 503) return { status: 'degraded', checks: {} }
        throw err
      }),
    refetchInterval: 30_000,
    retry: false,
  })
}
